import { ShowReport } from "components/reports/show";
import { CommonReport } from "components/reports/show/markup";
import { viewContainer } from "helpers/redux";
import { formatValue, REPORT_TYPES, typeSpecificProps } from "helpers/reports";
import React from "react";

class Report extends CommonReport {
    formatData = (data) => {
        return data.reduce((res, rowData) => {
            const { methodsByEventType, ...activityRow } = rowData;
            if (methodsByEventType.length > 0) {
                methodsByEventType.forEach((methodData) => {
                    const { eventTypeDisplayName, methods } = methodData;
                    if (methods.length > 0) {
                        methods.forEach((method) => {
                            const { methodName, callDates } = method;
                            callDates.forEach((callDate) => {
                                res.push({
                                    ...activityRow,
                                    eventTypeDisplayName,
                                    methodName,
                                    ...callDate,
                                });
                            });
                        });
                    }
                });
            }
            return res;
        }, []);
    };

    extractColumns = () => {
        return [
            {
                Header: "Имя пользователя",
                accessor: "userName",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
                Aggregated: () => "",
            },
            {
                Header: "ФИО",
                accessor: "fullName",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
                Aggregated: () => "",
            },
            {
                Header: "Тип действия",
                accessor: "eventTypeDisplayName",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
                Aggregated: () => "",
            },
            {
                Header: "Метод",
                accessor: "methodName",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
                Aggregated: () => "",
            },
            {
                Header: "Дата вызова метода",
                accessor: "date",
                ...typeSpecificProps({ clrType: "datetimeoffset" }),
                Cell: ({ value }) => formatValue(value, "datetimeoffset"),
                Aggregated: () => "",
            },
            {
                Header: "Статус запроса",
                accessor: "statusCode",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
                Aggregated: () => "",
            },
            {
                Header: "Тело ответа",
                accessor: "responseBody",
                ...typeSpecificProps({ clrType: "string" }),
                Cell: ({ value }) => value,
                Aggregated: () => "",
            },
        ];
    };

    tableExtraProps = () => {
        return {
            initialState: {
                groupBy: ["userName", "fullName", "eventTypeDisplayName", "methodName"],
            },
            data: this.formatData(this.props.data.data),
        };
    };
}

class OrganizationActivityReport extends ShowReport {
    renderBody = () => {
        return (
            <Report
                key={this.state.uniqKey}
                {...this.state}
                {...this.props}
                getItem={this.getItem}
                setPrintTableState={this.setPrintTableState}
            />
        );
    };
}

const ConfiguredOrganizationActivityReport = (props) => {
    return (
        <div className="page-content">
            <OrganizationActivityReport {...props} id={REPORT_TYPES.OrganizationActivityReport} transition="full" />
        </div>
    );
};

export default viewContainer(ConfiguredOrganizationActivityReport, "reports");
